<template>
   <div class="modal-container has-text-centered">
         <div class=" bottom20">
           <div class="has-background-dark"> <div class="is-size-4"><span class=" has-text-white">Add Group Members</span></div></div>
        </div>
        <div class="top5">Connections:</div>
        <div class="has-background-grey groupConnectChooser marginAutod has-text-left pad10 roundedCorners" id="memberList">
            <div v-for="(item, index) in connects" :key="index" ref="groupMembers" :ci="item.id">
                <input type="checkbox" class="checkbox"/> 
                <span v-if="item.id_recip == true && item.meOrig">&nbsp;{{item.fName + ' ' + item.lName}}</span>
                <span v-if="!item.meOrig">&nbsp;{{item.origF + ' ' + item.origL}}</span>
            </div>
            <div class="has-text-centered" v-if="connects.length == 0">No More Connections to Add</div>
        </div>

        <div class="top10"><button class="button is-small is-coolGreen" @click="addMembers">ADD</button>&nbsp;<button class="button is-small" @click="cancel">CANCEL</button></div>
        <br>
     
   </div>
</template>


<script>

import ShareTree from '../components/ShareTree'
import { AZEventBus } from '../components/AZEventBus'

export default{
    props: {
        groupId: Number,
        members: Array,
        callBack: Function
    },

    components: {
        ShareTree
    },

    data: function(){
        return {
            connects: [],
        }
    },

    mounted: function(){

        var self = this

        function w(d){
            az.addRemSpinner(false, 'id', 'memberList')

            let arr = []

        

            self.members.forEach(t => {
                arr.push(t.id_customer)
            })
            
            let a = d.r.filter(e => {
                return e.active == 1 && !arr.includes(e.id_orig2) && !arr.includes(e.id_recip2)
            })

            a.sort()
            self.connects = a
        }

        function n(){
            az.addRemSpinner(false, 'id', 'memberList')
        }

        az.addRemSpinner(true, 'id', 'memberList')
        this.$root.app.apiClient.get('subs/conn/', {}, w, n)
 
    },

    methods: {
        cancel: function(){
            this.$emit('close')
        },
        addMembers: function(){

            let self = this
            let toInclude = [];

             this.$refs.groupMembers.forEach(e => {
               if(e.firstChild.checked){
                   toInclude.push(parseInt(e.attributes.ci.value))
               }
            })

            if(toInclude.length == 0)
                return

            function w(d){
                self.callBack(d)
            }

            function n(){

            }

            this.$root.app.apiClient.post('auth/account/addmembers', {aclId: this.groupId, toInclude: toInclude}, w, n)

           
        }

    }

}
</script>


<style scoped>
    .modal-container{
        max-width: 400px;
    }

    .title{
        margin: 0 50px 0 50px
    }
</style>